import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Fish } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const cleanEmail = (email || "").trim().toLowerCase();
      const cleanPassword = (password || "").trim();
      const data = await login(cleanEmail, cleanPassword);
      if (data.user.role !== "admin") {
        toast.error("This account is not an admin");
        return;
      }
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--color-primary)] px-6" data-testid="admin-login-page">
      <div className="bg-white rounded-lg p-10 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <Fish className="w-7 h-7 text-[color:var(--color-primary)]" />
          <div className="font-display text-2xl text-[color:var(--color-primary)]">AlikamaFish Admin</div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-gray-600">Email</label>
            <input
              required type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 border border-[color:var(--color-border)] rounded px-3 py-2"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-gray-600">Password</label>
            <input
              required type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-1 border border-[color:var(--color-border)] rounded px-3 py-2"
              data-testid="admin-login-password"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
